import axios from '../../axios'

/*
 * 一分段表管理接口
 */

// 新增一分段表
export const addSegment = (data) => {
    return axios({
        url: '/api/data/wish/base/segment',
        method: 'POST',
        data
    })
}

// 编辑一分段表
export const editSegment = (data) => {
    return axios({
        url: '/api/data/wish/base/segment',
        method: 'PUT',
        data
    })
}

// 删除一分段表
export const deleteSegment = (data) => {
    return axios({
        url: '/api/data/wish/base/segment',
        method: 'DELETE',
        data
    })
}

// 获取一分段表列表
export const getSegmentList = (data) => {
    return axios({
        url: '/api/data/wish/base/segment',
        method: 'GET',
        data
    })
}

// 获取一分段表详情
export const getSegmentInfo = (data) => {
    return axios({
        url: '/api/data/wish/base/segment/info',
        method: 'GET',
        data
    })
}

// 导入一分段表
export const importSegment = (data) => {
    return axios({
        url: '/api/data/wish/base/segment/import',
        method: 'POST',
        data
    })
}

// 导出一分段表
export const exportSegment = (data) => {
    return axios({
        url: '/api/data/wish/base/segment/export',
        method: 'POST',
        data
    })
}

// 批量更新一分段表
export const updateSegment = (data) => {
    return axios({
        url: '/api/data/wish/base/segment/batch/update',
        method: 'POST',
        data
    })
}

// 批量删除一分段表
export const queryDelSegment = (data) => {
    return axios({
        url: '/api/data/wish/base/segment/batch/delete',
        method: 'POST',
        data
    })
}

// 一分段表模板构建
export const importBuild = (data) => {
    return axios({
        url: '/api/data/wish/base/segment/build',
        method: 'POST',
        data
    })
}

// 一分段表模板合并
export const importMerge = (data) => {
    return axios({
        url: '/api/data/wish/base/segment/merge',
        method: 'POST',
        data
    })
}
// 一分段表合并模板
export const importMergeSegment = (data) => {
    return axios({
        url: '/api/data/wish/base/segment/import/merge',
        method: 'POST',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/dataManage/segmentTable.js